import ChangeExcessServicesMock from './ChangeExcessServicesMock';
import ChangeExcessServices from './ChangeExcessServices';

const isMockingService = process.env.VUE_APP_MOCKING_SERVICES === 'true' || process.env.VUE_APP_MOCKING_SERVICES === true;
export default isMockingService ? ChangeExcessServicesMock : ChangeExcessServices;
